import * as Yup from "yup";
import { deliveryModes } from "../utils/constants/deliveryModes";

const autoBidSchema = ({
  currentStartingBid,
  currentMaximumBid,
  t // Pass the translation function here
}) => {
  return Yup.object().shape({
    start_bid_amount: Yup.number()
      .positive(t('Start bid amount must be greater than 0'))
      .test(
        'is-multiple-of-100',
        t(`Start bid must be a multiple of 100`),
        function (value) {
          return (value % 100) === 0;
        }
      )
      .test(
        'is-less-than-max',
        t(`Start bid must be less than the maximum bid`),
        function (value) {
          const { maximum_bid_amount } = this.parent;
          return !maximum_bid_amount || value < maximum_bid_amount;
        }
      )
      .test(
        'is-greater-than-current-starting',
        // Handling dynamic price interpolation
        `${t('Start bid must be greater than the current starting bid')}${currentStartingBid > 0 ? ` ${t('of')} $${currentStartingBid}` : ""}`,
        function (value) {
          return (value > currentStartingBid);
        }
      )
      .required(t("Start bid amount is a required field!")),
    maximum_bid_amount: Yup.number()
      .positive(t('Maximum bid amount must be greater than 0'))
      .test(
        'is-multiple-of-100',
        t(`Maximum bid must be a multiple of 100`),
        function (value) {
          return (value % 100) === 0;
        }
      )
      .test(
        'is-greater-than-start',
        t('Maximum bid must be greater than the start bid'),
        function (value) {
          const { start_bid_amount } = this.parent;
          return !start_bid_amount || value > start_bid_amount;
        }
      )
      .test(
        'is-greater-than-current-maximum',
        `${t('Maximum bid must be greater than the current maximum bid')}${currentMaximumBid > 0 ? ` ${t('of')} $${currentMaximumBid}` : ""}`,
        function (value) {
          return (value > currentMaximumBid);
        }
      )
      .required(t("Maximum bid amount is a required field!")),
    delivery_mode: Yup.string()
      .oneOf([deliveryModes.Pickup, deliveryModes.Dropoff])
  });
}

export {
  autoBidSchema
};